// Shared payment form choices — values must match backend constants/statuses.js
export const CURRENCY_CHOICES = [
  { id: 'ILS', label: '₪ שקל' },
  { id: 'USD', label: '$ דולר' },
];

export const PAY_METHOD_CHOICES = [
  { id: 'bank_transfer', label: 'העברה בנקאית' },
  { id: 'credit_card',   label: 'כרטיס אשראי' },
  { id: 'paypal',        label: 'PayPal' },
  { id: 'cash',          label: 'מזומן' },
  { id: 'check',         label: "צ'ק" },
  { id: 'zelle',         label: 'Zelle' },
];

export const PAY_STATUS_CHOICES = [
  { id: 'pending',  label: 'ממתין' },
  { id: 'paid',     label: 'שולם' },
  { id: 'failed',   label: 'נכשל' },
  { id: 'refunded', label: 'הוחזר' },
];
